/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getFileImportActions } from "api/services/fileImport";
import { fileImportQueryKeys } from "./fileImportQueryKeys";

export function useGetFileImportActions(id: string, options: UseQueryOptions) {
  return useQuery({
    queryKey: fileImportQueryKeys.fileImportActions(id),
    queryFn: () => getFileImportActions(id).then((res) => res.data),
    ...options,
  });
}
